import ReactDOMServer from 'react-dom/server'
import { MdInfoOutline } from 'react-icons/md'

import './index.scss'

const TooltipHeaderTemplate = ({
  className,
  title,
}: {
  className?: string
  title: string
}): string => `<div class="ag-cell-label-container ${className}" role="presentation">
                <span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                <div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
                  <span data-ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
                  <span data-ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>
                  <span data-ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>
                  <span data-ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>
                  <div class="tooltip-column-header">
                    <span>${title}</span>
                    ${ReactDOMServer.renderToString(<MdInfoOutline size={15} />)}
                  </div>
                  <span data-ref="eFilter" class="ag-header-icon ag-filter-icon" />
                </div>
              </div>`

export default TooltipHeaderTemplate
